import Table from './Table';
import { StyledBody as Body, Row, Label, Value } from './Table.styles';

const StyledTable = {
  Table,
  Body,
  Row,
  Label,
  Value,
};

export default StyledTable;
